import { Col, Row, Modal, Form, Switch, message } from "antd";
import { useTranslation } from "react-i18next";
import Title from "../../UI/Title/Title";
import { useState, useEffect, Dispatch } from "react";
import { ComponentType } from "./componentType";
import { UseMutateAsyncFunction, useMutation } from "react-query";
import { createComponent, editComponent } from "../../../api/refcomponents";
import AddEditModal from "../../UI/ModalComponent/AddEditModal/addeditcomponent";
import { AxiosResponse } from "axios";
import InputName from "../../UI/InputNumberComponent/InputName";
type propsType = {
  component?: ComponentType | undefined;
  openComponent: boolean;
  id?: string | number;
  setOpenComponent: React.Dispatch<React.SetStateAction<boolean>>;
  page: number;
  filter: boolean | undefined;
  search: string;
  setPaginatedtComponent: Dispatch<any>;
  ComponentMutation: UseMutateAsyncFunction<
    AxiosResponse<any, any>,
    unknown,
    {
      limit: number;
      q: string;
      isActive?: boolean | undefined;
    },
    unknown
  >;
};
export const AddEditComponent = ({
  openComponent,
  setOpenComponent,
  id,
  component,
  page,
  search,
  filter,
  setPaginatedtComponent,
  ComponentMutation,
}: propsType) => {
  const [open, setOpen] = useState(false);
  const [t] = useTranslation("common");
  const [form] = Form.useForm();
  const [, setError] = useState("");

  const [isActive, setIsActive] = useState<boolean>(
    component ? component?.isActive : true
  );
  const isEdit = () => {
    return !!id;
  };

  const onError = (error: any, variables: ComponentType, context: unknown) => {
    if (setError) {
      setError(error.response.data.message);
      message.error({
        content: error.response.data.message,
        duration: 10,
        onClick: () => {
          message.destroy();
        },
      });
    }
  };
  const { mutate: mutateCreateUpdate, isLoading: isSaving } = useMutation(
    !isEdit() ? "createComponent" : "editComponent",
    !isEdit()
      ? (component: ComponentType) => createComponent(component)
      : (component: ComponentType) => editComponent(id, component),
    {
      onSuccess: (res) => {
        setOpen(false);
        setOpenComponent(false);
        message.success("Complete successfully");
        ComponentMutation({
          q: search,
          isActive: filter,
          limit: page * 8 + 8,
        }).then((res: any) => {
          setPaginatedtComponent(res.data?.data);
        });
      },
      onError,
    }
  );
  const handleFinish = () => {
    const newComponent = form.getFieldsValue();
    for (const key in newComponent) {
      if (newComponent[key] === undefined) {
        if (key === "isActive") {
          newComponent[key] = true;
        } else {
          newComponent[key] = null;
        }
      } else if (
        typeof newComponent[key] === "string" &&
        newComponent[key].trim() === ""
      ) {
        newComponent[key] = null;
      }
    }
    mutateCreateUpdate(newComponent);
  };

  const [InputValue, setInputValue] = useState(false);

  const handleInputChange = (event: any) => {
    setInputValue(event);
  };
  const [editStatus] = useState(isEdit());
  useEffect(() => {
    if (editStatus) {
      setInputValue(true);
    }
  }, [editStatus]);
  return (
    <>
      <Modal
        closable={false}
        maskClosable={false}
        width={490}
        centered
        open={openComponent}
        onCancel={() => setOpenComponent(false)}
        cancelText={t("cancel")}
        okButtonProps={{
          style: {
            height: "40px",
            width: "100px",
            background: "#1677FF",
            color: "#fff",
          },
          disabled: !InputValue,
        }}
        cancelButtonProps={{
          style: {
            color: "#1677FF",
            border: "1px solid #1677FF",
            height: "40px",
            width: "100px",
          },
        }}
        okText={isEdit() ? `${t("save")}` : `${t("add")}`}
        onOk={() => {
          setOpen(true);
        }}
      >
        <Title
          title={isEdit() ? `${t("edit-component")}` : `${t("add-component")}`}
        />
        {isEdit() && (
          <span className="modaltitleEdit">
            {t("edit-details-for")} {component?.name}
          </span>
        )}
        <Form
          layout="vertical"
          form={form}
          id="ComponentForm"
          onFinish={handleFinish}
        >
          <Row>
            <Col span={14} style={{ marginTop: "20px" }}>
              <Form.Item
                initialValue={component?.name}
                name="name"
                label={t("component-name")}
                rules={[
                  {
                    required: true,
                    message: "component name is required",
                  },
                ]}
              >
                <InputName maxLength={50} onChange={handleInputChange} />
              </Form.Item>
              <Form.Item name="isActive" label={`${t("status")}`}>
                <Switch
                  checkedChildren={`${t("active")}`}
                  unCheckedChildren={`${t("inactive")}`}
                  checked={isActive}
                  disabled={isEdit() ? false : true}
                  onChange={(num: boolean) => {
                    setIsActive(num);
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
      <AddEditModal
        form="ComponentForm"
        open={open}
        setOpen={setOpen}
        name={<span>{component?.name}</span>}
        title={`${t("modal-component")}`}
        id={id}
        isSaving={isSaving}
      />
    </>
  );
};
